import { type JSX, lazy, Suspense } from 'react'
import type { ObservationHistoryChartProps } from '#src/components/observation/ObservationHistoryChartImpl.tsx'

// Lazy-load the chart implementation so recharts (~70 KB gzipped, its only
// importer in the app) is split out of the initial bundle. The chart is never
// above the fold — it renders inside the participant observation page, order
// display, and the relevant-observations panel — so a brief Suspense gap while
// the chunk loads is invisible in practice.
const ObservationHistoryChartImpl = lazy(() =>
  import('#src/components/observation/ObservationHistoryChartImpl.tsx').then(
    (m) => ({ default: m.ObservationHistoryChartImpl })
  )
)

export function ObservationHistoryChart(
  props: ObservationHistoryChartProps
): JSX.Element {
  return (
    <Suspense fallback={null}>
      <ObservationHistoryChartImpl {...props} />
    </Suspense>
  )
}
